





















import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import Summary from '../components/DashboardView/Summary/Summary.vue';
import ChartGroup from '../components/DashboardView/ChartGroup/ChartGroup.vue';
import Spinner from '../components/common/Spinner/Spinner.vue';
import { axiosApiInstance } from '@/utils/axiosInstances';

export default Vue.extend({
  components: {
    GNB,
    Summary,
    ChartGroup,
    Spinner,
  },
  data(): {
    selectedCharacteristic: { characteristic: string; isLabelProp: boolean };
    datasetType: string;
  } {
    return {
      selectedCharacteristic: { characteristic: '', isLabelProp: false },
      datasetType: '',
    };
  },
  async created() {
    const parsedURL = this.$route.path.split('/');
    const datasetIdx = parsedURL.indexOf('dataset');
    const labelsetIdx = parsedURL.indexOf('labelset');

    try {
      /** Get dataset infomation */
      this.datasetType = (
        await axiosApiInstance.get(
          `/api/v1/datasets/${this.$route.params.datasetId}`,
        )
      ).data.result.type;

      await this.$store.dispatch('getChartAnalysisData', {
        APIURL: `/api/v1/datasets/${parsedURL[datasetIdx + 1]}/analysis/file`,
      });

      if (labelsetIdx != -1) {
        await this.$store.dispatch('getLabelChartAnalysisData', {
          APIURL: `/api/v1/labelsets/${parsedURL[labelsetIdx + 1]}`,
        });
        await this.$store.dispatch('getSchemaChartAnalysisData', {
          APIURL: `/api/v1/labelsets/${parsedURL[labelsetIdx + 1]}`,
        });
      }
    } catch (error) {
      console.error(error);
      alert('오류가 발생했습니다.');
      this.$router.push('/');
    }
  },
  computed: {
    isLabelset() {
      const labelsetIdx = this.$route.path.split('/').indexOf('labelset');
      return labelsetIdx != -1;
    },
  },
  methods: {
    onUpdateSelectedCharacteristic(
      characteristic: string,
      isLabelProp: boolean,
    ) {
      if (!characteristic)
        this.selectedCharacteristic = {
          characteristic: '',
          isLabelProp: false,
        };
      else this.selectedCharacteristic = { characteristic, isLabelProp };
    },
  },
});
